import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from "../plugins/axios";

Vue.use(VueRouter);

const routes = [
    ////////////////////////////////////////////////////////////////////////////
    // 사용자
    ////////////////////////////////////////////////////////////////////////////
    {
        path: "/",
        component: () => import('../pages/client/Main.vue'),
        props: true,
    },
    {
        path: "/login",
        component: () => import('../pages/client/Login.vue'),
        props: true,
    },
    {
        path: "/join",
        component: () => import('../pages/client/Join.vue'),
        props: true,
    },
    {
        path: "/idpw",
        component: () => import('../pages/client/Idpw.vue'),
        props: true,
    },
    {
        path: "/search",
        component: () => import('../pages/client/Search.vue'),
        props: true,
    },
    {
        path: "/mypage",
        component: () => import('../pages/client/mypage/Mypage.vue'),
        props: true,
    },
    {
        path: "/terms/tos",
        component: () => import('../pages/client/terms/TermsOfService.vue'),
        props: true,
    },
    {
        path: "/terms/privacy",
        component: () => import('../pages/client/terms/Privacy.vue'),
        props: true,
    },
    {
        path: "/terms/protection-policy",
        component: () => import('../pages/client/terms/ProtectionPolicy.vue'),
        props: true,
    },
    {
        path: "/terms/cash-policy",
        component: () => import('../pages/client/terms/CashPolicy.vue'),
        props: true,
    },
    {
        path: "/board/event",
        component: () => import('../pages/client/board/EventList.vue'),
        props: true,
    },
    {
        path: "/board/event/:_board",
        component: () => import('../pages/client/board/EventView.vue'),
        props: true,
    },
    {
        path: "/center/notifications",
        component: () => import('../pages/client/center/Notification.vue'),
        props: true,
    },
    {
        path: "/center/notifications/:_notification",
        component: () => import('../pages/client/center/Notification.vue'),
        props: true,
    },
    {
        path: "/center/faqs",
        component: () => import('../pages/client/center/Faq.vue'),
        props: true,
    },
    {
        path: "/center/questions",
        component: () => import('../pages/client/center/Question.vue'),
        props: true,
    },
    {
        path: "/center/questions/create",
        component: () => import('../pages/client/center/Question.vue'),
        props: true,
    },
    {
        path: "/center/questions/:_question/edit",
        component: () => import('../pages/client/center/Question.vue'),
        props: true,
    },
    {
        path: "/center/questions/:_question",
        component: () => import('../pages/client/center/Question.vue'),
        props: true,
    },
    {
        // 마이페이지 - 회원정보
        path: "/mypage/profile",
        component: () => import('../pages/client/mypage/Profile.vue'),
        props: true,
    },
    {
        // 마이페이지 - 회원정보
        path: "/mypage/vaccount",
        component: () => import('../pages/client/mypage/MypageVaccount.vue'),
        props: true,
    },
    {
        // 마이페이지 - 포인트내역
        path: "/mypage/points",
        component: () => import('../pages/client/mypage/Point.vue'),
        props: true,
    },
    {
        // 마이페이지 - 장바구니
        path: "/mypage/shop/carts",
        component: () => import('../pages/client/mypage/shop/Cart.vue'),
        props: true,
    },
    {
        // 마이페이지 - 주문배송조회
        path: "/mypage/shop/purchases",
        component: () => import('../pages/client/mypage/shop/Purchase.vue'),
        props: true,
    },
    {
        // 마이페이지 - 주문배송조회 데테일
        path: "/mypage/shop/orders/:_orders",
        component: () => import('../pages/client/mypage/shop/PurchaseDetail.vue'),
        props: true,
    },
    {
        // 마이페이지 - ebook 열람
        path: "/mypage/shop/ebooks",
        component: () => import('../pages/client/mypage/shop/EBook.vue'),
        props: true,
    },
    {
        // 마이페이지 - 상품권 교환소 - 교환 내역
        path: "/mypage/exchange",
        component: () => import('../pages/client/mypage/Exchange.vue'),
        props: true,
    },
    {
        // 마이페이지 - 나누리상품권 - 주문 내역
        path: "/mypage/nshop/orders",
        component: () => import('../pages/client/mypage/nshop/NshopOrderList.vue'),
        props: true,
    },
    {
        // 마이페이지 - 캐시내역
        path: "/mypage/cashes/inquiry",
        component: () => import('../pages/client/mypage/Cash.vue'),
        props: true,
    },
    {
        // 마이페이지 - 이벤트 참여내역
        path: "/mypage/event",
        component: () => import('../pages/client/mypage/event/Roulette.vue'),
        props: true,
    },
    {
        // 마이페이지 - 캐시선물내역
        path: "/mypage/cashes/gift",
        component: () => import('../pages/client/mypage/CashGift.vue'),
        props: true,
    },
    {
        // 마이페이지 - 캐시선물하기
        path: "/mypage/cashes/give",
        component: () => import('../pages/client/mypage/CashGive.vue'),
        props: true,
    },
    {
        // 마이페이지 - 캐시충전하기
        path: "/mypage/cashes/charge",
        component: () => import('../pages/client/mypage/CashCharge.vue'),
        props: true,
    },
    {
        // 마이페이지 - 캐시선물받기
        path: "/mypage/cashes/take",
        component: () => import('../pages/client/mypage/CashTake.vue'),
        props: true,
    },
    {
        // 마이페이지 - 보증금내역
        path: "/mypage/deposits",
        component: () => import('../pages/client/mypage/deposits/MypageDepositList.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/mypage/gshop/orders",
        component: () => import('../pages/client/mypage/gshop/Order.vue'),
        props: true,
    },
    {
        // 마이페이지 - 배송상품 구매내역
        path: "/mypage/dshop/orders",
        component: () => import('../pages/client/mypage/dshop/Order.vue'),
        props: true,
    },
    
    {
        // 상품권 구매하기 (양식)
        path: "/purchase",
        component: () => import('../pages/client/purchase/PurchaseForm.vue'),
        props: true,
    },
    {
        // 상품권 구매하기 (결과)
        path: "/purchase/gain",
        component: () => import('../pages/client/purchase/PurchaseGain.vue'),
        props: true,
    },
    {
        // 상품권 구매하기 (결과)
        path: "/purchase/done",
        component: () => import('../pages/client/purchase/PurchaseDone.vue'),
        props: true,
    },
    {
        // 상품권 교환소
        path: "/exchange",
        component: () => import('../pages/client/exchange/ExchangeList.vue'),
        props: true,
    },
    {
        // 상품권 교환소
        path: "/exchange/:code",
        component: () => import('../pages/client/exchange/ExchangeForm.vue'),
        props: true,
    },
    {
        // 상품권 교환소
        path: "/exchange-gifts/:_gift",
        component: () => import('../pages/client/exchange/ExchangeGift.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/gshop/giftcards",
        component: () => import('../pages/client/gshop/GiftcardList.vue'),
        props: true,
    },
    {
        // 상품권 브랜드 몰
        path: "/gshop/brand",
        component: () => import('../pages/client/gshop/GiftcardBrandList.vue'),
        props: true,
    },
    {
        // 상품권 브랜드 기프트카드
        path: "/gshop/brand/giftcards",
        component: () => import('../pages/client/gshop/GiftcardList2.vue'),
        props: true,
    },
    {
        // 상품권 기프트카드 검색 리스트
        path: "/gshop/brand/giftcards/search",
        component: () => import('../pages/client/gshop/GiftcardSearchList.vue'),
        props: true,
    },
    {
        // 모바일 상품권 몰 선택
        path: "/gshop",
        component: () => import('../pages/client/gshop/Gshop.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/order",
        component: () => import('../pages/client/shop/Order.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/gift-order",
        component: () => import('../pages/client/shop/GiftOrder.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/gift-orders/:_giftOrder",
        component: () => import('../pages/client/shop/GiftDetails.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/exchange",
        component: () => import('../pages/client/shop/Exchange.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/exchange-order",
        component: () => import('../pages/client/shop/ExchangeOrder.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/products/:_product",
        component: () => import('../pages/client/shop/Product.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/products",
        component: () => import('../pages/client/shop/Shopping.vue'),
        props: true,
    },
    {
        // 
        path: "/shop/ebook",
        component: () => import('../pages/client/shop/Ebook.vue'),
        props: true,
    },
    {
        // 
        path: "/shop/ebook/:_product",
        component: () => import('../pages/client/shop/Product.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/bestseller",
        component: () => import('../pages/client/shop/BestSeller.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/bestseller/:_product",
        component: () => import('../pages/client/shop/Product.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/children",
        component: () => import('../pages/client/shop/Children.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/children/:_product",
        component: () => import('../pages/client/shop/Product.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/independent",
        component: () => import('../pages/client/shop/Independent.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/independent/:_product",
        component: () => import('../pages/client/shop/Product.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/discount",
        component: () => import('../pages/client/shop/Discount.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/discount/:_product",
        component: () => import('../pages/client/shop/Product.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/result",
        component: () => import('../pages/client/shop/Result.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/gift-result",
        component: () => import('../pages/client/shop/GiftResult.vue'),
        props: true,
    },
    {
        // 상품권 몰
        path: "/shop/exchange-result",
        component: () => import('../pages/client/shop/ExchangeResult.vue'),
        props: true,
    },
    {
        // 배송상품 주문
        path: "/dshop/order",
        component: () => import('../pages/client/dshop/DeliveryOrder.vue'),
        props: true,
    },
    {
        // 배송상품 리스트
        path: "/dshop/products",
        component: () => import('../pages/client/dshop/DeliveryList.vue'),
        props: true,
    },
    {
        // 배송상품 검색
        path: "/dshop/products/search",
        component: () => import('../pages/client/dshop/DeliverySearchList.vue'),
        props: true,
    },
    {
        // 배송상품 상세
        path: "/dshop/products/:_product",
        component: () => import('../pages/client/dshop/DeliveryView.vue'),
        props: true,
    },
    {
        // 결제완료
        path: "/dshop/result",
        component: () => import('../pages/client/dshop/DeliveryResult.vue'),
        props: true,
    },
    {
        path: "/event/hunt",
        component: () => import('../pages/client/event/hunt/Hunt.vue'),
        props: true,
    },
    {
        // 캐시 리워드
        path: "/offerwall",
        component: () => import('../pages/client/offerwall/Offerwall.vue'),
        props: true,
    },
    //{
    //    // 룰렛 이벤트 페이지
    //    path: "/event/roulette",
    //    component: () => import('../pages/client/event/roulette/Roulette.vue'),
    //    props: true,
    //},
    {
       // 클로버위크 이벤트 페이지
       path: "/event/clover",
       component: () => import('../pages/client/event/clover/index.vue'),
       props: true,
    },
    {
        // 룰렛 이벤트 페이지
        path: "/event/roullet_",
        component: () => import('../pages/client/event/roulette/Roullet_.vue'),
        props: true,
    },
    ////////////////////////////////////////////////////////////////////////////
    // 플러그인
    ////////////////////////////////////////////////////////////////////////////
    {
        // 관리자 메인
        path: '/certification',
        component: () => import('../pages/client/Certification.vue'),
        props: true,
    },
    {
        path: '/plugins/kcp/cert/request',
        component: () => import('../pages/plugins/kcp/KCPCertRequest.vue'),
        props: true
    },
    {
        path: '/plugins/kcp/cert/response',
        component: () => import('../pages/plugins/kcp/KCPCertResponse.vue'),
        props: true
    },
    {
        path: '/plugins/kcp/pay/result',
        component: () => import('../pages/plugins/kcp/KCPPayResult.vue'),
        props: true
    },
    {
        path: '/plugins/nice/pay/result',
        component: () => import('../pages/plugins/nice/NICEPayResult.vue'),
        props: true
    },
    {
        path: "/plugins/korpay/request",
        component: () => import("../pages/plugins/korpay/request.vue"),
        props: true,
    },
    {
        path: "/plugins/korpay/result",
        component: () => import("../pages/plugins/korpay/result.vue"),
    },
    {
        path: "/plugins/toss/pay/result",
        component: () => import("../pages/plugins/toss/result.vue"),
    },
    {
        path: '/specification/:_order',
        component: () => import(/* webpackChunkName: "console-app" */ '../components/client/popup/specification.vue'),
        props: true
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {

    let accessToken = sessionStorage.getItem("accessToken");

    axios.defaults.headers.common['Authorization'] = accessToken ? `Bearer ${accessToken}` : "";

    next();
});

export default router
